import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import BillingData from "features/retornar-unidade/steps/BillingData";
import DirectDebit from "features/retornar-unidade/steps/DirectDebit";
import Meter from "features/retornar-unidade/steps/Meter";
import SuccessRegister from "features/retornar-unidade/steps/SuccessRegister";
import { fetchCustomerMe } from "features/retornar-unidade/services/customerApi";
import {
  registerValuesNewUnit,
  resetStateNewUnit,
} from "store/actions/add-new-unit-actions";

export function useRetornarUnidade(): { stepContent: React.ReactNode } {
  const { selectedUnit, addNewUnitReducer } = useSelector(
    // @ts-ignore
    (state) => ({
      // @ts-ignore
      selectedUnit: state.selectUnitReducer.selectedUnit,
      // @ts-ignore
      addNewUnitReducer: state.addNewUnitReducer,
    })
  );
  const dispatch = useDispatch();
  const { step } = addNewUnitReducer;

  const requestUserInfo = useCallback(async () => {
    const data = await fetchCustomerMe();
    localStorage.setItem("@UltragazEmpresarial:loginEmail", data.email);
    return data;
  }, []);

  useEffect(() => {
    const address = selectedUnit?.address?.filter((add) => {
      return add?.addressType === "SHIP_TO";
    })[0];
    const addressShipLetterTo = selectedUnit?.address?.filter((add) => {
      return add?.addressType === "SHIP_LETTER_TO";
    })[0];

    dispatch(
      registerValuesNewUnit({
        address,
        addressShipLetterTo,
        unitInstanceId: selectedUnit?.instanceId,
        name: selectedUnit?.name,
        condominiumName: selectedUnit?.condominiumName,
      })
    );
    requestUserInfo();

    return () => {
      dispatch(resetStateNewUnit());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stepContent = useMemo(() => {
    return (
      {
        1: <Meter />,
        2: <BillingData />,
        3: <DirectDebit />,
        4: <SuccessRegister />,
      }[step] || <Meter />
    );
  }, [step]);

  return { stepContent };
}
